/* eslint-disable @typescript-eslint/naming-convention */
export enum topicAttributeTypesEnum {
    createdBy,
    dateCreated,
    lastModifiedBy,
    lastModifiedDate,
    lastAutoSaveDate,
    tags,
    alerts
}
